import { combineReducers, configureStore } from "@reduxjs/toolkit";
import componentSlice from "../Reducer/componentSlice";
import customerSlice from "../Reducer/customerSlice";
import bookingSlice from "../Reducer/bookingSlice";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "root",
  storage,
};
const rootReducer = combineReducers({
  component: componentSlice,
  customer: customerSlice,
  booking: bookingSlice
})
const persistedReducer = persistReducer(persistConfig, rootReducer)
export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
});

export const persistor = persistStore(store);

export default store;